import { FCI_ERROR } from "@searchui-searchforms/shared/fci";
import type { HierarchicalFieldGroup } from "@searchui-searchforms/shared/form-metadata";
import { fciFetch } from "@/shared/lib/fci";
import type { GetNestedHierarchyItemProps } from "./types";

export const getNestedHierarchyItem = ({ field, hierarchy, parents, formId }: GetNestedHierarchyItemProps) => {
    const { fieldName, assertion, eventType, relation } = hierarchy;
    const parentObject = Object.fromEntries(parents.map((value, index) => [`parent${index + 1}`, value]));
    const params = new URLSearchParams({
        collectionId: formId,
        fieldName,
        assertion,
        eventType: String(eventType),
        relation,
        required: String(field.features?.required ?? false),
        ...parentObject,
    });

    const url = `/api/searchforms/form-metadata/hierarchical-field?${params.toString()}`;

    return fciFetch<HierarchicalFieldGroup>(url, {
        fci: {
            // Fetches child options for a hierarchical field in the form
            // If it fails, a required form element is missing
            // and the user cannot complete the task
            errorType: FCI_ERROR.MissingElement,
            errorInfo: "getNestedHierarchyItem",
        },
    });
};
